






















































































import {
  ref,
  defineComponent,
  toRefs,
  reactive,
  inject,
  computed,
} from '@vue/composition-api'

import { createMediaItemOccurences } from '@/shared/api'
import { alertSymbol } from '@/shared/state-management/symbols'
import CloseButton from '@/components/custom/CloseButton.vue'
import AddLinks from './AddLinks.vue'
export default defineComponent({
  name: 'CreateMediaItemOccurences',
  components: {
    CloseButton,
    AddLinks,
  },
  props: {
    textbook: Object,
    textbookIssue: Object,
  },
  setup(props, { root, emit }) {
    const MediaUploadForm = ref(null)
    const data = reactive({
      valid: true,
      files: [],
      links: [],
      pages: [],
      category: '',
    })

    const dragover = ref(false)

    const $alert = inject(alertSymbol) as Function

    const rules = reactive({
      filesRules: [
        () =>
          data.files.length > 0 ||
          data.links.length > 0 ||
          root.$t('mediaItem.form.error.filesRequired'),
      ],
      linkRules: [
        (v: string) => {
          let isValid = true
          try {
            const link = new URL(v)
          } catch (e) {
            isValid = false
          }
          return isValid || root.$t('mediaItem.form.error.linkInvalid')
        },
      ],
      pagesRules: [
        (v: number[]) =>
          (!!v && v.length) || root.$t('mediaItem.form.error.pagesRequired'),
      ],
    })

    const pagesInIssue = computed((): number[] => {
      if (!props.textbookIssue) {
        return []
      }

      return new Array(props.textbookIssue.numberOfPages)
        .fill(null)
        .map((_: null, index: number) => index + 1)
    })

    const categories = computed(() =>
      props.textbook ? props.textbook.categories : []
    )

    const loadingData = ref(false)
    const addDropFile = (e: DragEvent) => {
      dragover.value = false
      // to support drag and drop https://github.com/vuetifyjs/vuetify/issues/7836#issuecomment-582841222
      data.files = Array.from(e.dataTransfer.files)
    }
    const addLink = () => {
      data.links.push('')
    }

    const deleteLink = (index: number): void => {
      data.links.splice(index, 1)
    }

    const submit = async (event: Event) => {
      event.preventDefault()
      event.stopPropagation()
      const form = MediaUploadForm.value
      if (!form.validate()) {
        return
      }

      loadingData.value = true
      try {
        const createdIds = await createMediaItemOccurences(
          data.files,
          data.links,
          props.textbookIssue.id,
          data.pages,
          data.category
        )

        $alert({
          text: root.$t('mediaItem.mediaItemOccurencesCreated', {
            number: createdIds.length,
          }),
          type: 'success',
        })
        emit('media-item-occurences-created')
        loadingData.value = false
      } catch (error) {
        loadingData.value = false
        throw error
      }
    }

    return {
      ...toRefs(data),
      ...toRefs(rules),
      loadingData,
      addDropFile,
      MediaUploadForm,
      submit,
      addLink,
      deleteLink,
      dragover,
      pagesInIssue,
      categories,
    }
  },
})
